<template>
    <div>
        <div class="alert alert-danger" v-if="errors.length>0">
            <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
            <b>Please contact support for further assistance.</b>
        </div>
        <div>
            <h5>Create your JustGiving page</h5>
            <p>Complete the details below and your page will be setup</p>
            <div class="form-group" v-if="just_giving_charities.length >1">
                <label for="pageTitle" class="control-label">Select Charity</label>
                <multiselect v-model="selectedCharity" placeholder="select charity" :options="just_giving_charities"
                             :option-height="104" :show-labels="false">
                    <template slot="singleLabel" slot-scope="props">
                        <span class="option__title">{{ props.option.name }}</span>
                    </template>
                    <template slot="option" slot-scope="props">
                        <div class="option_item">
                            <img class="option__image" :src="getLogoUrl(props.option.logo_url)">
                            <div class="option__desc">
                                <span class="option__title">{{ props.option.name }}</span>
                            </div>
                        </div>
                    </template>
                </multiselect>
            </div>
            <div v-if="selectedCharity" class="margin-bottom row">
                <div class="col-md-3"><img class="option__image" :src="getLogoUrl(selectedCharity.logo_url)"></div>
                <div class="col-md-9"> {{ selectedCharity.description }}</div>

            </div>

            <div class="form-group">
                <label for="pageTitle" class="control-label">Page Title</label>
                <input v-validate="'required'" autocomplete="off" class="form-control"
                       id="pageTitle"
                       type="text"
                       name="pageTitle"
                       v-model="pageData.pageTitle">
                <small v-show="vErrors.has('pageTitle')" class="text-danger">
                    {{ vErrors.first('pageTitle') }}
                </small>
            </div>


            <div
                v-if="!participant.registration_category.just_giving_default_target || participant.registration_category.just_giving_default_target == 0"
                class="form-group">
                <label for="target-amount">What's your target amount to raise?</label>
                <money v-model="pageData.targetAmount" id="target-amount" v-bind="money" class="form-control"></money>
            </div>


            <label>
                <input type="checkbox"
                       v-model="pageData.charityOptIn"
                       name="charityOptIn">
                <span class="label-text">I would like to opt in to receive communications from the charity</span>
            </label>

            <div class="form-group">
                <label for="pageStory" class="control-label">Page story</label>
                <textarea v-model="pageData.pageStory" class="form-control" id='pageStory'
                          placeholder="Tell us about your fundraising"></textarea>
            </div>


            <button type="submit" class="btn btn-ar btn-primary" v-on:click="registerPage">
                <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                Create page
            </button>


        </div>

    </div>
</template>


<script>
import Multiselect from 'vue-multiselect'

import {Money} from 'v-money';
import {currencySymbol} from "../../mixins/currency";
import {bs} from "../../mixins/bs";

export default {
    name: "just-giving-page",
    props: {
        participant: {
            type: Object,
            default: () => ({}),
            required: true
        },
        just_giving_charities: {
            type: Array,
            default: () => [],
            required: true
        },
        verifiedCredentials: {
            type: Object,
            default: () => ({}),
            required: true
        },
        bs: {
            type: String,
            default: () => 'bs3',
            required: false
        },
    },
    components: {
        Money,
        Multiselect
    },
    mixins: [currencySymbol, bs],
    data() {
        return {
            loading: false,
            selectedCharity: null,
            // page data
            pageData: {
                pageTitle: '',
                targetAmount: this.just_giving_charities[0].default_target ? this.just_giving_charities[0].default_target : 0,
                charityOptIn: false,
                pageStory: '',
            },
            errors: [],
            money: {
                decimal: '.',
                thousands: ',',
                prefix: this.convertCurrencyCodeToPrefix(this.participant.occasion.currency),
                suffix: '',
                precision: 2,
                masked: false
            },

        }
    },
    computed: {},
    created() {
        if (this.just_giving_charities.length == 1) {
            this.selectedCharity = this.just_giving_charities[0];
        }
    },
    methods: {
        getLogoUrl(url) {
            if (url.includes('http') || url.includes('https')) {
                return url;
            } else {
                return `https:${url}`;
            }
        },
        /**
         * Attempts to register a page
         */
        registerPage() {

            this.loading = true;
            this.errors = [];

            this.$validator.validateAll().then((result) => {
                if (result) {

                    axios.post('/just-giving/register-page.json',
                        {
                            participantId: this.participant.id,
                            userCredentials: this.verifiedCredentials,
                            pageData: this.pageData,
                            charityId: this.selectedCharity.charity_id,
                            eventId: this.selectedCharity.id
                        }).then(response => {

                        this.loading = false;

                        // if a page id is supplier the page has been created successfully
                        if (response.data.responseBody.pageId) {

                            window.location.href = '/users/' + this.participant.user_id + '/bookings/' + this.participant.id;
                        } else {

                            if (Array.isArray(response.data.responseBody)) {
                                this.errors = response.data.responseBody.map(e => e.desc);
                            } else {
                                this.errors.push(response.data.responseBody.error.desc);
                            }
                        }

                    }).catch((error) => {
                        this.errors.push(error.response.data.message);
                        this.loading = false;
                    })
                }
            });
        },
    }
}
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.option_item {
    display: flex;

}

.option__image {
    max-width: 100px;
    max-height: 100px;
    margin-right: 1em;
}


</style>



// WEBPACK FOOTER //
// src/Assets/components/JustGivingCharities/Page.vue